import { NgModule } from '@angular/core';
import { LOCALE_ID } from '@angular/core';
import { MessageService } from '@progress/kendo-angular-l10n';
import { ErrorHandlingService } from './services/error-handling-service';
import { BrowserPrintService } from './services/browser.print.service';
//import { AppHttpInterceptor } from './interceptors/app.http.interceptor';
//import { HTTP_INTERCEPTORS } from '@angular/common/http';

@NgModule({
  imports: [
    ],
    providers: [
        {
            provide: MessageService
        },
        {
            provide: LOCALE_ID,
            useValue: 'en-US'
        },
        ErrorHandlingService,
        BrowserPrintService
      //{
      //  provide: HTTP_INTERCEPTORS,
      //  useClass: AppHttpInterceptor,
      //  multi: true 
      //}
    ]
})
export class CoreModule { }
